import { ExpenseKindEnum, type Tax } from "@finway-group/shared/lib/models"
import { getDefaultTaxRateObject } from "~Shared/utils/helper.utils"
import { NO_TAX_RATE } from "../config/consts"

export const getInitialTaxRate = (taxes: Array<Tax>, kind: ExpenseKindEnum) => {
    const defaultTax = getDefaultTaxRateObject(taxes)
    if (kind === ExpenseKindEnum.HOSPITALITY) {
        return defaultTax.taxRate === 0 ? defaultTax : { _id: NO_TAX_RATE }
    }
    return defaultTax
}
